import _flatten from 'underscore/cjs/flatten.js'

export const DESTINATIONS_BY_GROUP = [
  {
    'label': 'Popular destinations in Asia',
    'options': [
      {
        'value': 'CHN',
        'text': 'China'
      },
      {
        'value': 'IND',
        'text': 'India'
      },
      {
        'value': 'IDN',
        'text': 'Indonesia (Bali)'
      },
      {
        'value': 'JPN',
        'text': 'Japan'
      },
      {
        'value': 'THA',
        'text': 'Thailand'
      },
      {
        'value': 'VNM',
        'text': 'Vietnam'
      }
    ]
  },
  {
    'label': 'Popular destinations in the Pacific',
    'options': [
      {
        'value': 'AUS',
        'text': 'Australia'
      },
      {
        'value': 'FJI',
        'text': 'Fiji'
      },
      {
        'value': 'NZL',
        'text': 'New Zealand'
      }
    ]
  },
  {
    'label': 'Popular destinations in Europe',
    'options': [
      {
        'value': 'GBR',
        'text': 'United Kingdom'
      },
      {
        'value': 'ITA',
        'text': 'Italy'
      },
      {
        'value': 'FRA',
        'text': 'France'
      },
      {
        'value': 'DEU',
        'text': 'Germany'
      },
      {
        'value': 'ESP',
        'text': 'Spain'
      }
    ]
  },
  {
    'label': 'Popular destinations in the Americas',
    'options': [
      {
        'value': 'USA',
        'text': 'USA'
      },
      {
        'value': 'CAN',
        'text': 'Canada'
      },
      {
        'value': 'MEX',
        'text': 'Mexico'
      },
      {
        'value': 'BRA',
        'text': 'Brazil'
      }
    ]
  },
  {
    'label': 'All countries',
    'options': [
      {
        'value': 'ALA',
        'text': 'Aland Islands'
      },
      {
        'value': 'ALB',
        'text': 'Albania'
      },
      {
        'value': 'DZA',
        'text': 'Algeria'
      },
      {
        'value': 'ASM',
        'text': 'American Samoa'
      },
      {
        'value': 'AND',
        'text': 'Andorra'
      },
      {
        'value': 'AGO',
        'text': 'Angola'
      },
      {
        'value': 'AIA',
        'text': 'Anguilla'
      },
      {
        'value': 'ATA',
        'text': 'Antarctica'
      },
      {
        'value': 'ATG',
        'text': 'Antigua and Barbuda'
      },
      {
        'value': 'ARG',
        'text': 'Argentina'
      },
      {
        'value': 'ARM',
        'text': 'Armenia'
      },
      {
        'value': 'ABW',
        'text': 'Aruba'
      },
      {
        'value': 'AUT',
        'text': 'Austria'
      },
      {
        'value': 'AZE',
        'text': 'Azerbaijan'
      },
      {
        'value': 'BHS',
        'text': 'Bahamas'
      },
      {
        'value': 'BHR',
        'text': 'Bahrain'
      },
      {
        'value': 'BGD',
        'text': 'Bangladesh'
      },
      {
        'value': 'BRB',
        'text': 'Barbados'
      },
      {
        'value': 'BEL',
        'text': 'Belgium'
      },
      {
        'value': 'BLZ',
        'text': 'Belize'
      },
      {
        'value': 'BEN',
        'text': 'Benin'
      },
      {
        'value': 'BMU',
        'text': 'Bermuda'
      },
      {
        'value': 'BTN',
        'text': 'Bhutan'
      },
      {
        'value': 'BOL',
        'text': 'Bolivia'
      },
      {
        'value': 'BES',
        'text': 'Bonaire, Sint Eustatius and Saba'
      },
      {
        'value': 'BIH',
        'text': 'Bosnia and Herzegovina'
      },
      {
        'value': 'BWA',
        'text': 'Botswana'
      },
      {
        'value': 'BVT',
        'text': 'Bouvet Island'
      },
      {
        'value': 'BRA',
        'text': 'Brazil'
      },
      {
        'value': 'IOT',
        'text': 'British Indian Ocean Territory'
      },
      {
        'value': 'BRN',
        'text': 'Brunei Darussalam'
      },
      {
        'value': 'BGR',
        'text': 'Bulgaria'
      },
      {
        'value': 'BDI',
        'text': 'Burundi'
      },
      {
        'value': 'CPV',
        'text': 'Cabo Verde'
      },
      {
        'value': 'KHM',
        'text': 'Cambodia'
      },
      {
        'value': 'CMR',
        'text': 'Cameroon'
      },
      {
        'value': 'CAN',
        'text': 'Canada'
      },
      {
        'value': 'CYM',
        'text': 'Cayman Islands'
      },
      {
        'value': 'CHL',
        'text': 'Chile'
      },
      {
        'value': 'CHN',
        'text': 'China'
      },
      {
        'value': 'CXR',
        'text': 'Christmas Island'
      },
      {
        'value': 'CCK',
        'text': 'Cocos Islands'
      },
      {
        'value': 'COL',
        'text': 'Colombia'
      },
      {
        'value': 'COM',
        'text': 'Comoros'
      },
      {
        'value': 'COG',
        'text': 'Congo'
      },
      {
        'value': 'COK',
        'text': 'Cook Islands'
      },
      {
        'value': 'CRI',
        'text': 'Costa Rica'
      },
      {
        'value': 'HRV',
        'text': 'Croatia'
      },
      {
        'value': 'CUB',
        'text': 'Cuba'
      },
      {
        'value': 'CUW',
        'text': 'Curaçao'
      },
      {
        'value': 'CYP',
        'text': 'Cyprus'
      },
      {
        'value': 'CZE',
        'text': 'Czechia'
      },
      {
        'value': 'CIV',
        'text': 'Côte d\'Ivoire'
      },
      {
        'value': 'DNK',
        'text': 'Denmark'
      },
      {
        'value': 'DJI',
        'text': 'Djibouti'
      },
      {
        'value': 'DMA',
        'text': 'Dominica'
      },
      {
        'value': 'DOM',
        'text': 'Dominican Republic'
      },
      {
        'value': 'ECU',
        'text': 'Ecuador'
      },
      {
        'value': 'EGY',
        'text': 'Egypt'
      },
      {
        'value': 'SLV',
        'text': 'El Salvador'
      },
      {
        'value': 'GBR',
        'text': 'United Kingdom'
      },
      {
        'value': 'GNQ',
        'text': 'Equatorial Guinea'
      },
      {
        'value': 'ERI',
        'text': 'Eritrea'
      },
      {
        'value': 'EST',
        'text': 'Estonia'
      },
      {
        'value': 'SWZ',
        'text': 'Eswatini'
      },
      {
        'value': 'ETH',
        'text': 'Ethiopia'
      },
      {
        'value': 'FLK',
        'text': 'Falkland Islands (Malvinas)'
      },
      {
        'value': 'FRO',
        'text': 'Faroe Islands'
      },
      {
        'value': 'FJI',
        'text': 'Fiji'
      },
      {
        'value': 'FIN',
        'text': 'Finland'
      },
      {
        'value': 'FRA',
        'text': 'France'
      },
      {
        'value': 'GUF',
        'text': 'French Guiana'
      },
      {
        'value': 'PYF',
        'text': 'French Polynesia'
      },
      {
        'value': 'ATF',
        'text': 'French Southern Territories'
      },
      {
        'value': 'GAB',
        'text': 'Gabon'
      },
      {
        'value': 'GMB',
        'text': 'Gambia'
      },
      {
        'value': 'GEO',
        'text': 'Georgia'
      },
      {
        'value': 'DEU',
        'text': 'Germany'
      },
      {
        'value': 'GHA',
        'text': 'Ghana'
      },
      {
        'value': 'GIB',
        'text': 'Gibraltar'
      },
      {
        'value': 'GRC',
        'text': 'Greece'
      },
      {
        'value': 'GRL',
        'text': 'Greenland'
      },
      {
        'value': 'GRD',
        'text': 'Grenada'
      },
      {
        'value': 'GLP',
        'text': 'Guadeloupe'
      },
      {
        'value': 'GUM',
        'text': 'Guam'
      },
      {
        'value': 'GTM',
        'text': 'Guatemala'
      },
      {
        'value': 'GGY',
        'text': 'Guernsey'
      },
      {
        'value': 'GIN',
        'text': 'Guinea'
      },
      {
        'value': 'GNB',
        'text': 'Guinea-Bissau'
      },
      {
        'value': 'GUY',
        'text': 'Guyana'
      },
      {
        'value': 'HMD',
        'text': 'Heard Island and McDonald Islands'
      },
      {
        'value': 'VAT',
        'text': 'Holy See'
      },
      {
        'value': 'HND',
        'text': 'Honduras'
      },
      {
        'value': 'HKG',
        'text': 'Hong Kong'
      },
      {
        'value': 'HUN',
        'text': 'Hungary'
      },
      {
        'value': 'ISL',
        'text': 'Iceland'
      },
      {
        'value': 'IND',
        'text': 'India'
      },
      {
        'value': 'IDN',
        'text': 'Indonesia'
      },
      {
        'value': 'IRL',
        'text': 'Ireland'
      },
      {
        'value': 'IMN',
        'text': 'Isle of Man'
      },
      {
        'value': 'ISR',
        'text': 'Israel'
      },      
      {
        'value': 'ITA',
        'text': 'Italy'
      },
      {
        'value': 'JAM',
        'text': 'Jamaica'
      },
      {
        'value': 'JPN',
        'text': 'Japan'
      },
      {
        'value': 'JEY',
        'text': 'Jersey'
      },
      {
        'value': 'JOR',
        'text': 'Jordan'
      },
      {
        'value': 'KAZ',
        'text': 'Kazakhstan'
      },
      {
        'value': 'KEN',
        'text': 'Kenya'
      },
      {
        'value': 'KIR',
        'text': 'Kiribati'
      },
      {
        'value': 'KOR',
        'text': 'Korea (Republic of)'
      },
      {
        'value': 'KWT',
        'text': 'Kuwait'
      },
      {
        'value': 'KGZ',
        'text': 'Kyrgyzstan'
      },
      {
        'value': 'LAO',
        'text': 'Lao People\'s Democratic Republic'
      },
      {
        'value': 'LVA',
        'text': 'Latvia'
      },
      {
        'value': 'LSO',
        'text': 'Lesotho'
      },
      {
        'value': 'LBR',
        'text': 'Liberia'
      },
      {
        'value': 'LIE',
        'text': 'Liechtenstein'
      },
      {
        'value': 'LTU',
        'text': 'Lithuania'
      },
      {
        'value': 'LUX',
        'text': 'Luxembourg'
      },
      {
        'value': 'MAC',
        'text': 'Macao'
      },
      {
        'value': 'MDG',
        'text': 'Madagascar'
      },
      {
        'value': 'MWI',
        'text': 'Malawi'
      },
      {
        'value': 'MYS',
        'text': 'Malaysia'
      },
      {
        'value': 'MDV',
        'text': 'Maldives'
      },
      {
        'value': 'MLT',
        'text': 'Malta'
      },
      {
        'value': 'MHL',
        'text': 'Marshall Islands'
      },
      {
        'value': 'MTQ',
        'text': 'Martinique'
      },
      {
        'value': 'MRT',
        'text': 'Mauritania'
      },
      {
        'value': 'MUS',
        'text': 'Mauritius'
      },
      {
        'value': 'MYT',
        'text': 'Mayotte'
      },
      {
        'value': 'MEX',
        'text': 'Mexico'
      },
      {
        'value': 'FSM',
        'text': 'Micronesia (Federated States of)'
      },
      {
        'value': 'MDA',
        'text': 'Moldova'
      },
      {
        'value': 'MCO',
        'text': 'Monaco'
      },
      {
        'value': 'MNG',
        'text': 'Mongolia'
      },
      {
        'value': 'MNE',
        'text': 'Montenegro'
      },
      {
        'value': 'MSR',
        'text': 'Montserrat'
      },
      {
        'value': 'MAR',
        'text': 'Morocco'
      },
      {
        'value': 'MOZ',
        'text': 'Mozambique'
      },
      {
        'value': 'NAM',
        'text': 'Namibia'
      },
      {
        'value': 'NRU',
        'text': 'Nauru'
      },
      {
        'value': 'NPL',
        'text': 'Nepal'
      },
      {
        'value': 'NLD',
        'text': 'Netherlands'
      },
      {
        'value': 'NCL',
        'text': 'New Caledonia'
      },
      {
        'value': 'NZL',
        'text': 'New Zealand'
      },
      {
        'value': 'NIC',
        'text': 'Nicaragua'
      },
      {
        'value': 'NGA',
        'text': 'Nigeria'
      },
      {
        'value': 'NIU',
        'text': 'Niue'
      },
      {
        'value': 'NFK',
        'text': 'Norfolk Island'
      },
      {
        'value': 'MKD',
        'text': 'North Macedonia'
      },
      {
        'value': 'MNP',
        'text': 'Northern Mariana Islands'
      },
      {
        'value': 'NOR',
        'text': 'Norway'
      },
      {
        'value': 'OMN',
        'text': 'Oman'
      },
      {
        'value': 'PAK',
        'text': 'Pakistan'
      },
      {
        'value': 'PLW',
        'text': 'Palau'
      },
      {
        'value': 'PAN',
        'text': 'Panama'
      },
      {
        'value': 'PNG',
        'text': 'Papua New Guinea'
      },
      {
        'value': 'PRY',
        'text': 'Paraguay'
      },
      {
        'value': 'PER',
        'text': 'Peru'
      },
      {
        'value': 'PHL',
        'text': 'Philippines'
      },
      {
        'value': 'PCN',
        'text': 'Pitcairn'
      },
      {
        'value': 'POL',
        'text': 'Poland'
      },
      {
        'value': 'PRT',
        'text': 'Portugal'
      },
      {
        'value': 'PRI',
        'text': 'Puerto Rico'
      },
      {
        'value': 'QAT',
        'text': 'Qatar'
      },
      {
        'value': 'REU',
        'text': 'Reunion'
      },
      {
        'value': 'ROU',
        'text': 'Romania'
      },
      {
        'value': 'RWA',
        'text': 'Rwanda'
      },
      {
        'value': 'BLM',
        'text': 'Saint Barthélemy'
      },
      {
        'value': 'SHN',
        'text': 'Saint Helena, Ascension and Tristan da Cunha'
      },
      {
        'value': 'KNA',
        'text': 'Saint Kitts and Nevis'
      },
      {
        'value': 'LCA',
        'text': 'Saint Lucia'
      },
      {
        'value': 'MAF',
        'text': 'Saint Martin (French part)'
      },
      {
        'value': 'SPM',
        'text': 'Saint Pierre and Miquelon'
      },
      {
        'value': 'VCT',
        'text': 'Saint Vincent and the Grenadines'
      },
      {
        'value': 'WSM',
        'text': 'Samoa'
      },
      {
        'value': 'SMR',
        'text': 'San Marino'
      },
      {
        'value': 'STP',
        'text': 'Sao Tome and Principe'
      },
      {
        'value': 'SAU',
        'text': 'Saudi Arabia'
      },
      {
        'value': 'SEN',
        'text': 'Senegal'
      },
      {
        'value': 'SRB',
        'text': 'Serbia'
      },
      {
        'value': 'SYC',
        'text': 'Seychelles'
      },
      {
        'value': 'SLE',
        'text': 'Sierra Leone'
      },
      {
        'value': 'SGP',
        'text': 'Singapore'
      },
      {
        'value': 'SVK',
        'text': 'Slovakia'
      },
      {
        'value': 'SVN',
        'text': 'Slovenia'
      },
      {
        'value': 'SLB',
        'text': 'Solomon Islands'
      },
      {
        'value': 'ZAF',
        'text': 'South Africa'
      },
      {
        'value': 'SGS',
        'text': 'South Georgia and the South Sandwich Islands'
      },
      {
        'value': 'ESP',
        'text': 'Spain'
      },
      {
        'value': 'LKA',
        'text': 'Sri Lanka'
      },
      {
        'value': 'SUR',
        'text': 'Suriname'
      },
      {
        'value': 'SJM',
        'text': 'Svalbard and Jan Mayen'
      },
      {
        'value': 'SWE',
        'text': 'Sweden'
      },
      {
        'value': 'CHE',
        'text': 'Switzerland'
      },
      {
        'value': 'TWN',
        'text': 'Taiwan'
      },
      {
        'value': 'TJK',
        'text': 'Tajikistan'
      },
      {
        'value': 'TZA',
        'text': 'Tanzania'
      },
      {
        'value': 'THA',
        'text': 'Thailand'
      },
      {
        'value': 'TLS',
        'text': 'Timor-Leste'
      },
      {
        'value': 'TGO',
        'text': 'Togo'
      },
      {
        'value': 'TKL',
        'text': 'Tokelau'
      },
      {
        'value': 'TON',
        'text': 'Tonga'
      },
      {
        'value': 'TTO',
        'text': 'Trinidad and Tobago'
      },
      {
        'value': 'TUN',
        'text': 'Tunisia'
      },
      {
        'value': 'TUR',
        'text': 'Turkiye'
      },
      {
        'value': 'TKM',
        'text': 'Turkmenistan'
      },
      {
        'value': 'TCA',
        'text': 'Turks and Caicos Islands'
      },
      {
        'value': 'TUV',
        'text': 'Tuvalu'
      },
      {
        'value': 'GBR',
        'text': 'United Kingdom'
      },
      {
        'value': 'USA',
        'text': 'United States of America'
      },
      {
        'value': 'UGA',
        'text': 'Uganda'
      },
      {
        'value': 'ARE',
        'text': 'United Arab Emirates'
      },
      {
        'value': 'UMI',
        'text': 'United States Minor Outlying Islands'
      },
      {
        'value': 'URY',
        'text': 'Uruguay'
      },
      {
        'value': 'UZB',
        'text': 'Uzbekistan'
      },
      {
        'value': 'VUT',
        'text': 'Vanuatu'
      },
      {
        'value': 'VNM',
        'text': 'Vietnam'
      },
      {
        'value': 'VGB',
        'text': 'Virgin Islands (British)'
      },
      {
        'value': 'VIR',
        'text': 'Virgin Islands (U.S.)'
      },
      {
        'value': 'WLF',
        'text': 'Wallis and Futuna'
      },
      {
        'value': 'ESH',
        'text': 'Western Sahara'
      },
      {
        'value': 'ZMB',
        'text': 'Zambia'
      },
      {
        'value': 'ZWE',
        'text': 'Zimbabwe'
      }
    ]
  }
]

export const DESTINATIONS = (() => {
  const array = _flatten(DESTINATIONS_BY_GROUP.map(e => e.options))
    .map(e => ({
      text: e.text,
      value: e.value
    }))
  
  return [...new Map(array.map(item =>
    [item['value'], item])).values()]
})()
